import {
  Popover,
  Stack,
  Typography,
  Drawer,
  useTheme,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { LoginDialog, logout, OtpVerificationsDialog } from "@app/modules/auth";
import { imageSource, Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { DropDownMenu } from "./dropDownMenu";
import { useNavbarLogic } from "./nav-bar-logics";
import { WishtlistIcon } from "./wishlistIcon";
import { UserProfileMenu } from "./user-profile-menu/user-profile-menu";
import { useState } from "react";

interface NavLink {
  label: string;
  onClick?: () => void;
  action?: (dispatch: any, navigate: any, page: number) => void;
  icon?: string;
  color?: string;
  options?: {
    label: string;
    value: string;
    onClick: () => void;
  };
}

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  navLinks: NavLink[];
  page: number;
  isMobile?: boolean;
  handleLogoutClick: () => void;
}

const NavbarPopover = ({
  anchorEl,
  open,
  onClose,
  navLinks,
  page,
  isMobile,
  handleLogoutClick,
}: Props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    sellCarOption,
    isAuthenticated,
    data,
    LoginDialogs,
    otpVerificationsDialogs,
  } = useNavbarLogic();
  const [loginFormData, setLoginFormData] = useState();

  const allLinks: NavLink[] = [...navLinks];

  const menuContent = (
    <Stack sx={{ height: "100%", overflowY: "auto" }}>
      <Stack alignItems="center" spacing={2} p={2}>
        <img
          alt="logo"
          loading="lazy"
          src={imageSource.redLogo}
          style={{
            marginTop: 40,
            width: 155,
            height: 45,
            objectFit: "contain",
          }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: theme.palette.primary.main,
            fontSize: { sm: 15, md: 20 },
          }}
        >
          {Strings.common.kaizenMoter}
        </Typography>
        <Stack
          sx={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "center",
            gap: 4,
          }}
        >
          {/* <IconButton>
            <Icon
              icon={"material-symbols:search"}
              color={theme.palette.primary.main}
            />
          </IconButton> */}
          <WishtlistIcon onClose={onClose} />
        </Stack>
      </Stack>

      <Divider />

      <Stack p={2} spacing={2} minWidth={200} flex={1} alignItems={"center"}>
        {allLinks?.map((link, index) =>
          link?.label === Strings.navBar.sellCars ? (
            <DropDownMenu
              value={link?.label}
              shortOptions={sellCarOption}
              textColor={theme.palette.common.black}
            />
          ) : (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (link?.action) {
                  link?.action(dispatch, navigate, page);
                } else {
                  link?.onClick?.();
                }
                onClose();
              }}
            >
              {link?.icon && (
                <Icon
                  icon={link?.icon}
                  width={20}
                  style={{
                    marginRight: 8,
                    color: link?.color || "inherit",
                  }}
                />
              )}
              <Typography
                sx={{
                  fontWeight: link.icon ? 600 : 400,
                  color: link.color || "inherit",
                }}
              >
                {link.label}
              </Typography>
            </Stack>
          ),
        )}
        {isAuthenticated ? (
          <UserProfileMenu
            userName={`${data?.firstName || ""} ${data?.lastName || ""}`.trim()}
            onEditProfile={() => {}}
            onMyOrders={() => {}}
            onLogout={handleLogoutClick}
          />
        ) : (
          <Button
            onClick={() => {
              onClose();
              setTimeout(() => {
                LoginDialogs.show();
              }, 250);
            }}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              px: 3.5,
              fontFamily: "Work Sans",
            }}
          >
            {Strings.authPopup.logIn}
          </Button>
        )}
      </Stack>
    </Stack>
  );

  return (
    <>
      {isMobile ? (
        <Drawer
          anchor="right"
          open={open}
          onClose={onClose}
          sx={{ "& .MuiDrawer-paper": { width: 240 } }}
        >
          {menuContent}
        </Drawer>
      ) : (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {menuContent}
        </Popover>
      )}
      {LoginDialogs.visible && (
        <LoginDialog
          open={LoginDialogs.visible}
          onClose={LoginDialogs.hide}
          onClickOtpVerificationsDialog={() => {
            otpVerificationsDialogs.show();
            LoginDialogs.hide();
          }}
          setLoginFormData={setLoginFormData}
        />
      )}
      {otpVerificationsDialogs.visible && (
        <OtpVerificationsDialog
          open={otpVerificationsDialogs.visible}
          onClose={otpVerificationsDialogs.hide}
          loginFormData={loginFormData}
          onClickOtpVerifications={() => {
            otpVerificationsDialogs.hide();
            LoginDialogs.show();
          }}
        />
      )}
    </>
  );
};

export { NavbarPopover };
